import moment from "moment-timezone";
import { getMyZone } from "../../constants/getTimeDate";
import DateAndTimePicker from "../DateAndTimePicker";
import React, { useEffect, useRef, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styl
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { IMAGE_SUB_TYPE, IMAGE_TYPE } from "../../constants/ImageConstant";
import LocationAndExpcept from "../../constants/LocationAndExpcept";
import { constants } from "../../constants/constants";
import {
  createDestination,
  deleteDestinationData,
  getDestinatinDataLocation,
  updateDestination,
  cleanupDestinationImages,
} from "../../utils/ApiCalls/Destination";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import { addlog } from "../../utils/ApiCalls/Logs";
import { uploadData } from "../../utils/ApiCalls/Upload";
import { checkFields } from "../../utils/Validation/checkFields";


import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import UploadFileImageBanner2 from "../Banner/uploadFileImageBanner copy";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const DESTINATION_ALT_FIELDS = [
  "image_alt",
  "simplified_chinese_image_alt",
  "traditional_chinese_image_alt",
  "bahasa_image_alt",
];

const MySwal = withReactContent(Swal)

const DestinationInputs = ({ destination }) => {
  const [englishTitle, setEnglishTitle] = useState(
    destination?.englishTitle || ""
  );
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState(
    destination?.simplifiedChineseTitle || ""
  );
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState(
    destination?.traditionalChineseTitle || ""
  );
  const [currentLocation, setCurrentLocation] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [isDateEdit, setIsDateEdit] = useState(false);
  const originalValidDates = useRef({ valid_from: "", valid_to: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseFile, setTraditionalChineseFile] = useState(null);
  const [simplifiedChineseFile, setSimplifiedChineseFile] = useState(null);
  const [displayLocation, setDisplayLocation] = useState([]);
  const [url, setUrl] = useState(destination?.url || "");
  const [image, setImage] = useState(destination?.image || null);
  const [submitBtnState, setSubmitBtnState] = useState(false);
  const [traditional_chinese_image, setTraditional_chinese_image] =
    useState(null);

  const [valid_from, setValidFrom] = useState();
  const [valid_to, setValidTo] = useState();
  const [simplified_chinese_image, setSimplified_chinese_image] =
    useState(null);
  const [bahasaTitle, setBahasaTitle] = useState("");
  const [altText, setAltText] = useState({});
  const [bahasaFile, setBahasaFile] = useState(null);
  const [locationOption, setLocationOption] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (!destination?.id) setIsDateEdit(true);
    if (destination) {
      if (destination.image) {
        getLocationData();
      }
      setImage(destination?.image);
      setSimplified_chinese_image(destination?.simplified_chinese_image);
      setTraditional_chinese_image(destination?.traditional_chinese_image);
      setEnglishTitle(destination?.title);
      setSimplifiedChineseTitle(destination?.simplified_chinese_title);
      setTraditionalChineseTitle(destination?.traditional_chinese_title);
      setBahasaTitle(destination?.bahasa_title || "");
      setUrl(destination?.url);
      setAltText(pickAltText(destination, DESTINATION_ALT_FIELDS));
      if (destination.location_id)
        setDisplayLocation([destination.location_id]);
      if (destination?.is_active !== undefined) setIsActive(destination.is_active === 1);
    }
  }, [destination]);

  useEffect(() => {
    if (destination && locationOption.length > 0) {
      const tz = locationOption.find(l => l.id == destination.location_id)?.timezone || "Asia/Kuala_Lumpur";
      const initialValidFrom = destination?.valid_from ? moment.utc(destination.valid_from).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      const initialValidTo = destination?.valid_to ? moment.utc(destination.valid_to).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      setValidFrom(initialValidFrom);
      setValidTo(initialValidTo);
      originalValidDates.current = { valid_from: initialValidFrom, valid_to: initialValidTo };
      if (destination?.id) setIsDateEdit(false);
    }
  }, [destination, locationOption]);



  const handleCheckboxChange = () => {
    try {
      if (new Date(valid_to) < new Date()) {
        throw new Error(`Destination is expired`);
      }
      setIsActive(!isActive);
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e.message,
      });
    }
  };



  const getLocationData = async () => {
    let data = await getDestinatinDataLocation({ image: destination.image });

    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setCurrentLocation(data);
      setDisplayLocation(data?.map((item) => item.location_id) || []);
    }
  };

  const handleDisplayLocationChange = (selectedOptions) => {
    setDisplayLocation(selectedOptions);
  };
  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getAllLocations();

    if (data.error) {

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setLocationOption(data?.data || []);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const addDestination = async (e) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    e.preventDefault();
    let dataValues = {
      image,
      traditional_chinese_image,
      simplified_chinese_image,
      title: englishTitle,
      traditional_chinese_title: traditionalChineseTitle,
      simplified_chinese_title: simplifiedChineseTitle,
      bahasa_title: bahasaTitle,
      valid_from: valid_from,
      valid_to: valid_to,
      url,
      is_active: isActive ? 1 : 0,
      isDateEdit,
      ...altText,
    };

    try {
      if (selectedFile) {
        if (typeof selectedFile === "string") {
          dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.DESTINATION_IMG,
            subType: IMAGE_SUB_TYPE.ENGLISH_IMG,
          };
          let image = await uploadData(selectedFile, imageType, typeof destination?.image === 'string' ? destination.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);

          dataValues.image = image?.url;
        }
      } else {
        dataValues.image = ""
      }
      if (traditionalChineseFile) {
        if (typeof traditionalChineseFile === "string") {
          dataValues.traditional_chinese_image = traditionalChineseFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.DESTINATION_IMG,
            subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
          };
          let image = await uploadData(traditionalChineseFile, imageType, typeof destination?.traditional_chinese_image === 'string' ? destination.traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);

          dataValues.traditional_chinese_image = image?.url;
        }
      } else {
        dataValues.traditional_chinese_image = ""
      }
      if (simplifiedChineseFile) {
        if (typeof simplifiedChineseFile === "string") {
          dataValues.simplified_chinese_image = simplifiedChineseFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.DESTINATION_IMG,
            subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
          };
          let image = await uploadData(simplifiedChineseFile, undefined, typeof destination?.simplified_chinese_image === 'string' ? destination.simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);

          dataValues.simplified_chinese_image = image?.url;
        }
      }
      else {
        dataValues.simplified_chinese_image = ""
      }

      if (bahasaFile) {
        if (typeof bahasaFile === "string") {
          dataValues.bahasa_image = bahasaFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.DESTINATION_IMG,
            subType: IMAGE_SUB_TYPE.BAHASA_IMG,
          };
          let image = await uploadData(bahasaFile, imageType, typeof destination?.bahasa_image === 'string' ? destination.bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);
          dataValues.bahasa_image = image?.url;
        }
      } else {
        dataValues.bahasa_image = "";
      }

      let valid = checkFields(dataValues);
      if (valid) {

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: valid,
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } else {
        try {
          setError();
          // Compute, from the whole group's current state, which old image
          // files this save will orphan — an old value held by any location
          // in the group that won't match the new value being applied
          // everywhere. Sent once to the backend after all the location
          // saves below finish, so it doesn't depend on their ordering.
          const DESTINATION_IMAGE_FIELDS = ["image", "arabic_image", "bahasa_image", "simplified_chinese_image", "traditional_chinese_image"];
          const oldImageValues = new Set();
          currentLocation.forEach((item) => {
            DESTINATION_IMAGE_FIELDS.forEach((field) => {
              if (item[field]) oldImageValues.add(item[field]);
            });
          });
          const imagesToDelete = Array.from(oldImageValues).filter(
            (file) => !DESTINATION_IMAGE_FIELDS.some((field) => dataValues[field] === file)
          );

          await Promise.all(currentLocation.map(async item => {

            if (!displayLocation.includes(item.location_id)) {
              await deleteDestinationData(item.id)
            }
          }))
          await Promise.all(
            displayLocation.map(async (item, index) => {
              const locTimezone = locationOption.find(i => i.id == item)?.timezone || "Asia/Kuala_Lumpur";
              let values = {
                location_id: item,
                ...dataValues,
                valid_from: valid_from ? moment.tz(valid_from, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_from,
                valid_to: valid_to ? moment.tz(valid_to, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_to,
              };

              let data;
              if (destination?.id) {
                let locationValue = currentLocation.filter(
                  (data) => data.location_id === item
                );
                if (locationValue.length > 0) {
                  let { ...rest } = values;
                  if (item === destination.location_id) {
                    data = await updateDestination(locationValue[0].id, values);
                  } else {
                    data = await updateDestination(locationValue[0].id, rest);
                  }
                } else {
                  await createDestination({ ...values, recordIteration: index + 1 });
                }
              } else {
                values = {
                  ...values,
                  recordIteration: index + 1
                }
                data = await createDestination(values);
              }
              if (data?.error) {
                throw new Error(data.error);
              } else {
                if (destination?.id) {
                  addlog(
                    "Destination Updated",
                    "Destination",
                    {
                      id: destination.id,
                      title: values.title || destination.title,
                      url: url || destination.url,
                      location_id: destination.location_id,
                    },
                    userDetails.id
                  );
                } else {
                  addlog(
                    "Destination Created",
                    "Destination",
                    {
                      id: data.id,
                      title: data.title,
                      url: data.url,
                      location_id: item,
                    },
                    userDetails.id
                  );
                }
              }
            })
          );

          await cleanupDestinationImages(imagesToDelete);

          dispatch({
            type: "SET_LOADING",
            loading: false,
          });

          if (!destination.id) {
            navigate("/website/cms/homepage/destinations");
          } else {
            navigate("/website/cms/homepage/destinations");
            dispatch({
              type: "SET_ERROR_MESSAGE",
              errMess: { message: "Values updated", type: "success" },
            });
          }
        } catch (error) {
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.message || "Unknown error occurred",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addDestination}>
              <div className="card-body">
                <div className="row">
                  <LocationAndExpcept
                    displayLocation={displayLocation}
                    banner={destination}
                    locationOption={locationOption}
                    nondisplay
                    options={locationOption}
                    setDisplayLocation={setDisplayLocation}
                    handleDisplayLocationChange={handleDisplayLocationChange}
                  />

                  <div className="w-100"></div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">English Title</label>
                      <input
                        className="f_input"
                        // required
                        type="text"
                        value={englishTitle}
                        onChange={(e) => setEnglishTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Title
                      </label>
                      <input
                        className="f_input"
                        // required
                        type="text"
                        value={simplifiedChineseTitle}
                        onChange={(e) =>
                          setSimplifiedChineseTitle(e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Title
                      </label>
                      <input
                        className="f_input"
                        // required
                        type="text"
                        value={traditionalChineseTitle}
                        onChange={(e) =>
                          setTraditionalChineseTitle(e.target.value)
                        }
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Title</label>
                      <input
                        className="f_input"
                        type="text"
                        value={bahasaTitle}
                        onChange={(e) => setBahasaTitle(e.target.value)}
                      />
                    </div>
                  </div>

                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    mandatory={"*"}

                    image={
                      destination?.image
                        ? `${constants.MEDIAURL}/${destination?.image}`
                        : destination?.image
                    }
                    label={"English Destination Image"}
                    width={431}
                    height={431}
                    placeholder={"Upload English Destination Image"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"

                    // mandatory={displayLocation.find(location=>locationOption.find(l=> l.id===location)?.location_code === "CN") ? "*": ""}

                    width={431}
                    height={431}
                    image={
                      destination?.simplified_chinese_image
                        ? `${constants.MEDIAURL}/${destination?.simplified_chinese_image}`
                        : destination?.simplified_chinese_image
                    }
                    label={"Simplified Chinese Destination Image"}
                    placeholder={"Upload Simplified Chinese Destination Image "}
                    selectedFile={simplifiedChineseFile}
                    setSelectedFile={setSimplifiedChineseFile}
                  />

                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"

                    width={431}
                    height={431}
                    image={
                      destination?.traditional_chinese_image
                        ? `${constants.MEDIAURL}/${destination?.traditional_chinese_image}`
                        : destination?.traditional_chinese_image
                    }
                    label={"Traditional Chinese Destination Image "}
                    placeholder={
                      "Upload Traditional Chinese Destination Image "
                    }
                    selectedFile={traditionalChineseFile}
                    setSelectedFile={setTraditionalChineseFile}
                  />

                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    width={431}
                    height={431}
                    image={
                      destination?.bahasa_image
                        ? `${constants.MEDIAURL}/${destination?.bahasa_image}`
                        : destination?.bahasa_image
                    }
                    label={"Bahasa Destination Image"}
                    placeholder={"Upload Bahasa Destination Image"}
                    selectedFile={bahasaFile}
                    setSelectedFile={setBahasaFile}
                  />
                  <AltTextInput className="col-lg-3" label="English Destination Image Alt Text" field="image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Simplified Chinese Destination Image Alt Text" field="simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Traditional Chinese Destination Image Alt Text" field="traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Bahasa Destination Image Alt Text" field="bahasa_image_alt" values={altText} setValues={setAltText} />

                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Url</label>
                      <input
                        className="f_input"
                        // required
                        type="text"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-sm-6 col-6">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label"> Valid From <span style={{ color: "red" }}> *</span></label>
                          <DateAndTimePicker
                            value={valid_from}
                            min={moment(new Date()).format("YYYY-MM-DD")}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidFrom(val);
                              setValidTo("");
                              setIsDateEdit(
                                val !== originalValidDates.current.valid_from ||
                                "" !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label">Valid To <span style={{ color: "red" }}> *</span></label>
                          <DateAndTimePicker
                            value={valid_to}
                            min={valid_from ? moment(valid_from).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD")}
                            disabled={!valid_from}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidTo(val);
                              setIsDateEdit(
                                valid_from !== originalValidDates.current.valid_from ||
                                val !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {displayLocation.length > 0 && (
                      <p style={{ marginTop: "8px", fontSize: "13px", color: "#666" }}>
                        {displayLocation.length === 1
                          ? `* Dates will be saved in ${locationOption.find(i => i.id == displayLocation[0])?.location_name} timezone (${locationOption.find(i => i.id == displayLocation[0])?.timezone}). Your timezone is ${getMyZone()}`
                          : `* Dates will be saved in each location's own timezone and converted to UTC. Your timezone is ${getMyZone()}`}
                      </p>
                    )}
                  </div>

                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button disabled={submitBtnState} className="btn main_submit">
                  {destination?.id ? "Update" : "Add"} Destination
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default DestinationInputs;
